import { useTranslation } from 'next-i18next';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import ImageWrapper from '../../../../new-components/ImageWrapper';

interface AmenitiesInterface {
  name: string;
  imageUrl: string;
}

const CompoundAmenities = ({
  amenities
}: {
  amenities: AmenitiesInterface[];
}) => {
  const { t } = useTranslation('entity');
  const isMobile = useSelector((state: any) => state.app.isMobile);
  return (
    <Container>
      <h3 className="headline">{t('amenities')}</h3>
      <div className="amenities-container hide-scrollbar">
        {amenities.map(amenity => (
          <div key={amenity.name} className="amenity-item">
            <ImageWrapper
              src={amenity.imageUrl}
              alt={amenity.name}
              className="amenity-icon"
              width={26}
              height={26}
            />
            <span className="amenity-name">{amenity.name}</span>
          </div>
        ))}
      </div>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;

  .amenities-container {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    gap: 16px;
    overflow-x: auto;
    height: 80px;
    .amenity-item {
      display: flex;
      flex-direction: row;
      align-items: center;
      gap: 8px;

      span {
        color: #2c3138;
        font-family: materialRegular;
        font-size: 14px;
        line-height: 150%;
      }
    }
  }
`;

export default CompoundAmenities;
